import { StrictMode } from 'react';

import { createRoot } from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import { SWRConfig } from 'swr';

import App from './app';

import './lib/i18n';
import './lib/cronstrue-locales';

import './index.css';

if (import.meta.env.DEV) {
	import('./lib/viteErrorOverlay');

	if (import.meta.env.VITE_DEV_MOCK_API === true) {
		const { bootstrapDevMockSession } = await import('./lib/devMockSession');
		await bootstrapDevMockSession();

		// Playwright e2e mocks the API via `context.route` and blocks service
		// workers — starting MSW here would fail or race with those routes.
		if (import.meta.env.VITE_E2E !== 'true') {
			const { worker } = await import('./mocks/browser');
			await worker.start({ onUnhandledRequest: 'bypass' });
		}
	}
} else {
	// For deployment information
	console.info(`Build date: ${import.meta.env.VITE_BUILD_DATETIME}`);
	if (import.meta.env.VITE_BUILD_NUMBER) {
		console.info(`Build number: ${import.meta.env.VITE_BUILD_NUMBER}`);
	}
}

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
	<StrictMode>
		<ErrorBoundary
			fallback={
				<div style={{ padding: '2rem', textAlign: 'center' }}>
					<h1>Something went wrong</h1>
					<p>The application encountered a critical error.</p>
					<button onClick={() => window.location.reload()}>Reload</button>
				</div>
			}
			onError={(error, info) => console.error('Critical app error:', error, info)}
		>
			<SWRConfig
				value={{
					// Keep the data up to date every 10 minutes
					// refreshInterval: 10 * 60 * 1000,
					onError: (error) => console.error(error),
				}}
			>
				<App />
			</SWRConfig>
		</ErrorBoundary>
	</StrictMode>
);
